import React from 'react';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className="h-96 flex justify-center items-center">
      <div className="text-center">
        <h1 className="text-9xl font-bold">404</h1>
        <p className="text-2xl">Page not found</p>
        <button
          className="mt-12 px-8 py-2 bg-primary-800 hover:bg-primary-900 text-white font-bold rounded"
          onClick={goBack}
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
